var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.108,
    height: 20.501,
    viewBox: "0 0 16.108 20.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location",
    transform: "translate(-30 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M69.661,55.322a3.661,3.661,0,1,1,3.661-3.661A3.661,3.661,0,0,1,69.661,55.322Zm0-5.857a2.2,2.2,0,1,0,2.2,2.2A2.2,2.2,0,0,0,69.661,49.464Z",
    transform: "translate(-31.607 -31.607)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M38.054,32.5l-6.177-7.284q-.129-.164-.255-.33A7.972,7.972,0,0,1,30,20.054a8.054,8.054,0,0,1,16.108,0,7.969,7.969,0,0,1-1.622,4.83v0s-.22.288-.253.327ZM32.791,24s.171.226.21.274l5.053,5.959,5.059-5.967c.032-.04.2-.267.2-.268a6.517,6.517,0,0,0,1.326-3.948,6.589,6.589,0,1,0-13.179,0A6.52,6.52,0,0,0,32.792,24Z",
    transform: "translate(0)",
    fill: "#bcbcbc"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.467105e98e087d479ea236440ee5bb05.svg";
export { ForwardRef as ReactComponent };